import styled from 'styled-components';

export const HelpCenterStyled = styled.div`
  .card-wrap {
    cursor: pointer;
  }
  .content-wrap .Polaris-Link {
    &:hover {
      text-decoration: none;
    }
    span,
    p {
      color: #303030;
    }
  }
  #canny-changelog-button {
    background-color: #fff;
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
`;
